import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcAirCompressor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 101.88,
	height: 68,
	viewBox: "0 0 101.88 68.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 7.94 26.0 L 93.94 26.0 A 40.0 40.0 0.0 0 1 93.94 68.0 L 7.94 68.0 A 40.0 40.0 0.0 0 1 7.94 26.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.14,
			y: 26,
			width: 85.4,
			height: 42,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 36.94,
			cy: 19,
			rx: 4,
			ry: 4,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 67.44,
			cy: 16,
			rx: 8,
			ry: 8,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 36.07 15.1 L 65.29 8.42 M 36.97 23.14 L 67.29 24.07 M 17.44 26.0 L 17.44 21.5 M 12.94 21.5 L 17.44 16.5 M 17.44 0.0 L 17.44 16.5 M 13.94 8.4 L 21.14 14.7 M 14.94 5.7 L 20.64 10.5 M 15.54 3.0 L 19.94 7.0 M 88.44 26.0 L 88.44 22.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 12.94 12.0 L 22.44 21.5 L 12.94 21.5 Z M 85.44 12.0 L 91.44 12.0 L 85.44 22.5 L 91.44 22.5 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgAcAirCompressor;
